// --- Redux Imports
import { combineReducers, configureStore } from '@reduxjs/toolkit';
// --- Reducers
import { clearanceMemoReducers } from '../../clearances/store/all-reducers';

const appReducer = combineReducers({
    ...clearanceMemoReducers,
});

/**
 * rootReducer Function
 *
 * This function is responsible for handling the state of the Redux store.
 * It resets the state of the reducers when a specific action is dispatched.
 *
 * @param {Object} state - The current state of the Redux store.
 * @param {Object} action - The action dispatched to the Redux store.
 * @return {Object} The new state of the Redux store.
 */
const rootReducer = (state, action) => {
    // Check if the action type is 'RESET_REDUCERS'
    if (action.type === 'RESET_REDUCERS') {
        const { auth } = state;
        state = { auth };
    }

    return appReducer(state, action);
};

// Create the Redux store using the rootReducer
export const store = configureStore({
    reducer: rootReducer,
});

export default store;
